/**
 * Directive used to apply drag and drop sort to ui-select2 tag fields
 */
angular.module('qkr').directive('select2SortableDrag', ['$timeout', function($timeout) {
    return {
    	require: 'ngModel',
        restrict: 'A',
        transclude: true,
        link(scope, element, attrs, ngModel) {
            // Call select2 function to set data and all properties
            scope.applySortable = function() {
            	if (!attrs.disabled) {
	                element.select2('container').find('ul.select2-choices').sortable({
	                    containment: 'parent',
	                    start() {
	                        element.select2('onSortStart');
	                    },
	                    update() {
	                        element.select2('onSortEnd');
	                        element.trigger('change');
	                    }
	                });
            	}
            };

            // Watch the model for programmatic changes
            scope.$watch(() => {
            	scope.applySortable();
            });

            $timeout(() => {
                scope.applySortable();
            });
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/select2-sortable.js